
export default function StatsSection() {
  const stats = [
    {
      number: '10,000+',
      label: 'Guidelines Indexed',
      icon: 'ri-file-text-line',
      description: 'Comprehensive database of loan requirements'
    },
    {
      number: '4',
      label: 'Major Agencies',
      icon: 'ri-government-line',
      description: 'Fannie Mae, Freddie Mac, HUD, and VA'
    },
    {
      number: '99.9%',
      label: 'Uptime',
      icon: 'ri-shield-check-line',
      description: 'Reliable access when you need it most'
    },
    {
      number: '24/7',
      label: 'Support',
      icon: 'ri-customer-service-line',
      description: 'Expert assistance around the clock'
    }
  ];

  return (
    <section className="bg-slate-800 py-20 border-t border-slate-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Trusted by Mortgage Professionals
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            Join thousands of loan officers, underwriters, and mortgage professionals who rely on LoanGuide Pro for accurate, up-to-date guidelines.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-emerald-500 transition-colors">
                <i className={`${stat.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-4xl font-bold text-white mb-2">{stat.number}</div>
              <div className="text-lg font-semibold text-slate-300 mb-2">{stat.label}</div>
              <div className="text-sm text-slate-400">{stat.description}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-slate-700 rounded-2xl p-8 border border-slate-600">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to streamline your workflow?
            </h3>
            <p className="text-slate-400 mb-6 max-w-2xl mx-auto">
              Stop wasting time searching through multiple websites. Get instant access to all loan guidelines in one powerful platform.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-emerald-600 text-white px-8 py-3 rounded-lg hover:bg-emerald-500 font-semibold cursor-pointer whitespace-nowrap transition-colors shadow-lg">
                Start Free Trial
              </button>
              <button className="border border-slate-500 text-slate-300 px-8 py-3 rounded-lg hover:bg-slate-600 hover:border-slate-400 font-semibold cursor-pointer whitespace-nowrap transition-colors">
                View Pricing
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
